import React, { Component } from 'react';
import Avatar from 'material-ui/Avatar';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroller';
import Translate from 'translate';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import { connect } from "react-redux";
import animateScrollTo from "animated-scroll-to";
import { injectIntl } from "react-intl";
import Linkify from 'react-linkify';

import ReactTooltip from "react-tooltip";
import SendEmailModal from "../SendEmailModal";
import Util from 'util/Util';
import { DriveEta } from '@material-ui/icons';

class Timeline extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      accountSelected: null,
      sendEmailModalOpened: false,
    };
  }

  componentDidMount() {
    _.map( this.props.messages.data, ( item, index ) => {
      if( item.socialType === 'email' ) {
        this.renderIframeContent( item, `timeline-iframe-${item.id}` )
      }
    } )
  };

  renderIframeContent( message, id ) {
    const contentIframe = document.getElementById( id );
    let agentInitial = ''
    if(contentIframe) {
      if(message.agent){
        agentInitial= ` ${message.agent.name.substring(0, 1)}.${message.agent.lastname.substring(0, 1)}.`;
      }
         

      const doc = contentIframe.contentDocument || contentIframe.contentWindow.document;
      doc.open();
      doc.write( Util.cencoLinkifyContentEmail( message.content + ' ' + agentInitial ));
      doc.close();
      contentIframe.style.height = contentIframe.contentWindow.document.body.offsetHeight + 'px'
    }
  };

  handleMenuChange = ( event, index, value ) => {
    animateScrollTo( 0, {
      element: $( '#timelineBody' )[0],
      maxDuration: 1500,
    } );
    this.setState( { accountSelected: value },
      () => this.props.onReloadData( { account_incms: this.state.accountSelected } ) );
  };

  toggleSendEmailModal = (content) => {
    this.emailContent = content;
    this.setState( { sendEmailModalOpened: !this.state.sendEmailModalOpened } )
  };

  render() {
    const { data, messages, loadMore, intl, activeAccount, externalCustomer } = this.props;
    const channelNotEnabled = data.status !== 'open' && data.status !== 'in_progress' && data.status !== 'return';

    const total = parseInt( messages.total );
    const formattedMessages = _.chain( messages.data )
      .groupBy( dateObj => moment( dateObj.socialCreateTime || dateObj.updatedAt ).format( 'DD/MM/YYYY' ) ).value();

    const accounts = _.filter( _.get( data, 'accounts', [] ), { active: true } );
    
    return (
      <div>
        {accounts && accounts.length ?
          <div className="row align-items-center pt-3 px-3 pb-0">
            <div className="col-md-2">
              <Avatar src={data.webPathThumbnail}/>
            </div>
            <div className="col-md-7 pr-0">
              <p className="m-0">{data.name}</p>
              <DropDownMenu
                value={this.state.accountSelected}
                onChange={this.handleMenuChange}
                autoWidth={false}
                labelStyle={{
                  height: '32px',
                  paddingLeft: 0,
                  lineHeight: '40px'
                }}
                style={{
                  height: '32px'
                }}
                selectedMenuItemStyle={{
                  color: '#2e6c99',
                }}
                underlineStyle={{
                  marginLeft: 0
                }}
                iconStyle={{
                  right: '8px',
                  top: '-5px'
                }}
              >
                <MenuItem
                  value={null}
                  style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                  primaryText={intl.formatMessage( { id: "SelectAccount" } )}
                />
                {_.map( accounts, ( account, index ) =>
                  <MenuItem
                    value={account.account}
                    key={index}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={account.account}/>
                )}
              </DropDownMenu>
            </div>
          </div> : null
        }

        <div className={classNames('timeline-historical',{
          'timeline-historical-w-accounts': accounts && accounts.length,
          'timeline-historical-no-accounts': !accounts || !accounts.length,
        })} id="timelineBody">
          <InfiniteScroll
            pageStart={0}
            loadMore={() => loadMore({ account_incms: this.state.accountSelected })}
            hasMore={messages.data.length < total}
            loader={<div className="loader" key={0}><Translate id="loading"/>...</div>}
            useWindow={false}
          >
            <div className="ui-timline-container ui-timline-left theme-light timeline-sm">
              <section className="ui-timeline">
                {_.map( formattedMessages, ( messages, date ) =>
                  <div key={date}>
                    <article className="tl-item">
                      <div className="tl-body">
                        <div className="tl-entry">
                          <div className="tl-caption">
                            <a href="javascript:;" className="btn btn-primary btn-block">{date}</a>
                          </div>
                        </div>
                      </div>
                    </article>

                    {_.map( messages, ( item, index ) =>
                      <article key={index} className="tl-item">
                        <div className="tl-body">
                          <div className="tl-entry">
                            <div className="tl-time d-flex justify-content-between w-100 px-2 pb-1" style={{right: 0,height: 25}}>
                              <div>
                              {item.type === 'message' && item.direction === 'to_company' &&
                              <span>
                                <i data-tip={intl.formatMessage( { id: "forwardEmail" } )}
                                   className={classNames( 'fa fa-share pointer', {
                                     'color-purple': !channelNotEnabled,
                                     'color-gray-3': channelNotEnabled
                                   } )}
                                   data-for={item.id.toString()}
                                   onClick={channelNotEnabled ? 
                                      () => {} : 
                                      () => this.toggleSendEmailModal( 
                                        data.type==='email' ?
                                        `<div>Created at: ${item.socialCreateTime}<br>From: ${data.email}<br>To: ${item.direction}<br>Subject: ${data.snippet}<br><br>${item.content}</div>`
                                        :
                                        `<div>Created at: ${item.socialCreateTime}<br>From: ${data.name}<br>To: ${item.direction}<br>Channel: ${item.socialType}<br><br>${item.content}</div>`
                                      )}
                                />
                                <ReactTooltip id={item.id.toString()} place="bottom" type="dark" effect="solid"/>
                              </span>
                              }
                              </div>
                              <div>
                                <span className="text-small">{moment( item.socialCreateTime || item.updatedAt ).format( 'h:mm:ss A' )}</span>
                                {item.socialType === 'facebook' &&
                                <i className="fa fa-facebook-square ml-2 color-facebook"/>
                                }
                                {item.socialType === 'twitter' &&
                                <i className="fa fa-twitter-square ml-2 color-twitter"/>
                                }
                                {item.socialType === 'phone' && item.via !== 'phone_sms' && 
                                <i className="fa fa-phone-square ml-2"/>
                                }
                                {item.socialType === 'phone' && item.via === 'phone_sms' && 
                                <i className="fa fa-commenting-o ml-2"/>
                                }
                                {item.socialType === 'email' &&
                                <i className="fa fa-envelope color-danger ml-2"/>
                                }
                                {item.via && item.via !== 'email' ?
                                  <i data-tip={intl.formatMessage( { id: item.via } )} className={classNames( 'fa ml-1', {
                                    'fa-comments-o color-facebook': item.via === 'fb_chat',
                                    'fa-rss color-facebook': item.via === 'fb_feed',
                                    'fa-commenting-o color-facebook': item.via === 'fb_feed_comment',
                                    'fa-comments-o color-twitter': item.via === 'tw_chat',
                                    'fa-at color-twitter': item.via === 'tw_tweet_account',
                                    'fa-hashtag color-twitter': item.via === 'tw_tweet_hashtag',
                                  } )}>
                                    <ReactTooltip place="bottom" type="dark" effect="solid"/>
                                  </i> : null}
                                {item.failed &&(
                                  <i data-tip={intl.formatMessage( { id: "failed" } )}
                                    className={classNames( 'fa fa-circle color-danger ml-2')}/>
                                )}

                              </div>
                            </div>
                            {item.type === 'message' ?
                              item.direction === 'to_company' ?
                                <div className="tl-icon">
                                  <Avatar src={_.get( data, 'webPathThumbnail' )}/>
                                </div> :
                                <div className="tl-icon btn-icon-round btn-icon btn-icon-thin btn-info">
                                  <i className="fa fa-headphones"/>
                                </div> :
                              <div className="tl-icon btn-icon-round btn-icon btn-success">
                                <i className="fa fa-bell-o text-white"/>
                              </div>
                            }
                            <div className="tl-content pt-4">
                              <div className="text-small">
                                
                                  {item.type === 'status' &&
                                  <span><Translate id="statusChangeTo"/> { externalCustomer == 'apu' ? <Translate id={ `status.${item.status}` }  /> : item.status }</span>
                                  }
                                  {item.type === 'status' && <br/>}
                                  {item.socialType === 'email' ?
                                    <iframe frameBorder="0" className="w-100 timeline-iframe"
                                            id={`timeline-iframe-${item.id}`}>
                                    </iframe> 
                                    :<div>
                                      { item.content ? Util.cencoLinkifyContent(item.content) :' ' } {item.agent ? item.agent.name.substring(0, 1):''}.{item.agent ? item.agent.lastname.substring(0, 1):''}.
                                     </div>
                                  }
                                
                              </div>

                              <div>
                                {_.map( item.attachments, ( attachment, index ) =>
                                  <a key={index} href={attachment.webPathFileName}
                                     className="p-1 color-dark" target="_blank">
                                    <i className={classNames( 'fa', {
                                      'fa-image': attachment.mimeType && attachment.mimeType.indexOf( 'image' ) !== -1,
                                      'fa-paperclip': !attachment.mimeType || attachment.mimeType.indexOf( 'image' ) === -1
                                    } )}/>
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    )}
                  </div>
                )}
              </section>
            </div>
          </InfiniteScroll>
        </div>

        <SendEmailModal open={this.state.sendEmailModalOpened}
                        onClose={() => this.toggleSendEmailModal()}
                        channel={data}
                        activeAccount={activeAccount}
                        content={this.emailContent}
        />

      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  activeAccount: state.channelDetail.activeAccount,
  externalCustomer: state.settings.externalCustomer,
} );

module.exports = connect(
  mapStateToProps,
  null
)( injectIntl( Timeline ) );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/Timeline/index.js